export {
  default as hotTub,
  ReactComponent as HotTub,
} from '@assets/icons/features-and-amenities/hot-tub.svg'    
